import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { IRebrandingPromoModalProps } from 'reactApp/ui/RebrandingPromoModal/RebrandingPromoModal.types';

export const openRebrandingPromoModal = ({ onClose, ...data }: IRebrandingPromoModalProps) =>
    openPopupHelper({ popupName: popupNames.REBRANDING_PROMO_MODAL, data, onClose });

export const closeRebrandingPromoModal = () => closePopupHelper(popupNames.REBRANDING_PROMO_MODAL);
